import { Users, GraduationCap, Clock, Heart, Globe2 } from "lucide-react";

const STATS = [
  { icon: Users, k: "1,000+", l: "Lives transformed" },
  { icon: GraduationCap, k: "15+", l: "Years of coaching excellence" },
  { icon: Clock, k: "30,000+", l: "Hours taught live" },
  { icon: Heart, k: "4.9 / 5", l: "Average rating" },
];

export default function TrustStrip() {
  return (
    <section className="border-y border-sand-300 bg-sand-200/60">
      <div className="container-x py-7 md:py-9">
        <p className="text-center eyebrow flex items-center justify-center gap-2 mb-5">
          <Globe2 className="h-3.5 w-3.5" /> Transforming lives in USA · Canada · UK · UAE · Singapore · India
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {STATS.map(({ icon: Icon, k, l }) => (
            <div key={l} className="flex items-center gap-3">
              <span className="grid h-10 w-10 md:h-11 md:w-11 place-items-center rounded-full bg-white border border-sand-300 text-forest shrink-0">
                <Icon className="h-4 w-4 md:h-5 md:w-5" strokeWidth={1.6} />
              </span>
              <div>
                <div className="font-serif text-xl md:text-2xl text-forest leading-none">{k}</div>
                <div className="text-[11px] md:text-xs text-ink-soft mt-1">{l}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
